import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { RepasseService } from "../../../services/RepasseService";
import { ExercicioService } from "../../../services/ExercicioService";
import { UnidadeExecutoraService } from "../../../services/UnidadeExecutoraService";
import { UnidadeOrcamentariaService } from "../../../services/UnidadeOrcamentariaService";
import { AcaoService } from "../../../services/AcaoService";
import { ProgramaService } from "../../../services/ProgramaService";
import { GrupoService } from "../../../services/GrupoService";
import { ElementoService } from "../../../services/ElementoService";
import { ElementoItemService } from "../../../services/ElementoItemService";
import { IpgService } from "../../../services/IpgService";
import { FonteService } from "../../../services/FonteService";
import { IpuService } from "../../../services/IpuService";
import moment from "moment";

export default {
    name: "IndexRepasse",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciar Repasse Orçamentário',
                disabled: false,
                href: '/gerenciar-repasses-orcamentarios'
            },
            {
                text: 'Visualizar Repasse Orçamentário',
                disabled: true
            }
        ],
        repasse: {},
        itemSelected: [],
        exerciciosOptions: [],
        acaoOptions: [],
        ipuOptions: [],
        ipgOptions: [],
        grupoOptions: [],
        programaOptions: [],
        elementoOptions: [],
        elementoItemOptions: [],
        fonteOptions: [],
        unidadeExecutoraOptions: [],
        unidadeOrcamentariaOptions: [],
    }),
    created() {
        this.carregarRepasse(this.$route.params.id);
        this.listarExerciciosSelect();
        this.listarAcoesSelect();
        this.listarIpusSelect();
        this.listarIpgsSelect();
        this.listarGruposSelect();
        this.listarProgramasSelect();
        this.listarElementosItensSelect();
        this.listarElementosSelect();
        this.listarFontesSelect();
        this.listarUnidadeExecutoraSelect();
        this.listarUnidadeOrcamentariaSelect();
    },
    methods: {
        async carregarRepasse(id) {
            try {
                const response = await RepasseService.show(id);
                if (response && response.data) {
                    this.repasse = {
                        codigo_repasse: response.data.codigo_repasse,
                        exercicio: response.data.exercicio_id,
                        unidadeExecutoraOrigem: response.data.unidade_executora_origem_id,
                        unidadeExecutoraDestino: response.data.unidade_executora_destino_id,
                        programa: response.data.programa_id,
                        acao: response.data.acao_id,
                        grupo: response.data.grupo_id,
                        elemento: response.data.elemento_id,
                        elementoItem: response.data.elemento_item_id,
                        fonte: response.data.fonte_id,
                        ipu: response.data.ipu_id,
                        ipg: response.data.ipg_id,
                        data_repasse: response.data.data_repasse,
                        valor: response.data.valor,
                        dotacao_origem_id: response.data.dotacao_origem_id,
                        dotacao_destino_id: response.data.dotacao_destino_id
                    };
                } else {
                    console.error('Não foi possível carregar o Repasse');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao buscar o Repasse', error);
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.id,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarAcoesSelect() {
            try {
                const response = await AcaoService.select();

                if (response) {
                    this.acaoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_acao} - ${el.descricao_acao}`,
                            value: el.id,
                        };
                    });
                    this.acaoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarIpusSelect() {
            try {
                const response = await IpuService.select();
                if (response) {
                    this.ipuOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipu} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipuOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarIpgsSelect() {
            try {
                const response = await IpgService.select();
                if (response) {
                    this.ipgOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipg} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipgOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.grupoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.grupoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarProgramasSelect() {
            try {
                const response = await ProgramaService.select();
                if (response) {
                    this.programaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_programa} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.programaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarUnidadeExecutoraSelect() {
            try {
                const response = await UnidadeExecutoraService.select();
                if (response) {
                    this.unidadeExecutoraOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeExecutoraOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarUnidadeOrcamentariaSelect() {
            try {
                const response = await UnidadeOrcamentariaService.select();
                if (response) {
                    this.unidadeOrcamentariaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeOrcamentariaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementoItemOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoItemOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarElementosSelect() {
            try {
                const response = await ElementoService.select();
                if (response) {
                    this.elementoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async listarFontesSelect() {
            try {
                const response = await FonteService.select();
                if (response) {
                    this.fonteOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_fonte} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.fonteOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os Aprovações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Aprovações:', error);
            }
        },
        async goBack() {
            window.history.back();
        },
        // Métodos para buscar textos das opções
        getExercicioText(exercicioId) {
            if (!exercicioId) return '-';
            const exercicio = this.exerciciosOptions.find(opt => opt.value === exercicioId);
            return exercicio ? exercicio.text : '-';
        },
        getAcaoText(acaoId) {
            if (!acaoId) return null;
            const acao = this.acaoOptions.find(opt => opt.value === acaoId);
            return acao ? acao.text : null;
        },
        getUnidadeExecutoraText(unidadeId) {
            if (!unidadeId) return null;
            const unidade = this.unidadeExecutoraOptions.find(opt => opt.value === unidadeId);
            return unidade ? unidade.text : null;
        },
        getProgramaText(programaId) {
            if (!programaId) return null;
            const programa = this.programaOptions.find(opt => opt.value === programaId);
            return programa ? programa.text : null;
        },
        getGrupoText(grupoId) {
            if (!grupoId) return null;
            const grupo = this.grupoOptions.find(opt => opt.value === grupoId);
            return grupo ? grupo.text : null;
        },
        getElementoText(elementoId) {
            if (!elementoId) return null;
            const elemento = this.elementoOptions.find(opt => opt.value === elementoId);
            return elemento ? elemento.text : null;
        },
        getElementoItemText(elementoItemId) {
            if (!elementoItemId) return null;
            const elementoItem = this.elementoItemOptions.find(opt => opt.value === elementoItemId);
            return elementoItem ? elementoItem.text : null;
        },
        getFonteText(fonteId) {
            if (!fonteId) return null;
            const fonte = this.fonteOptions.find(opt => opt.value === fonteId);
            return fonte ? fonte.text : null;
        },
        // Métodos de formatação
        formatDate(date) {
            if (!date) return '-';
            if (date.includes('/')) {
                return date;
            }
            return moment(date).format('DD/MM/YYYY');
        },
        formatCurrency(value) {
            if (value == null || value === undefined) return 'R$ 0,00';
            const numValue = typeof value === 'string' ? parseFloat(value) : value;
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numValue);
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + '...';
        }
    }
};
